import {createContext, useContext} from "react";
import {ToastModel} from "types/toast";

export type ToastContextType = {
    showToast: (options: ToastModel) => void;
};

export const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error("useToast must be used within a ToastContext");
    }

    return context;
};